/*
---------------------------------------------------------
 Back to top / Scrollspy
---------------------------------------------------------
*/
const menu = document.querySelector("nav");
// const menuItems = menu.querySelectorAll('.nav-link');
// const bttBtn = document.getElementById("back-to-top");

const scroll = () => {
    if(window.scrollY > 50){
        menu.classList.remove("bg-white/40");
        menu.classList.add("bg-background/80","backdrop-blur-md","shadow-sm")
    } else {
        menu.classList.remove("bg-background/80","backdrop-blur-md","shadow-sm");
        menu.classList.add("bg-white/40");
    }
    // window.scrollY > 500 ? bttBtn.style.opacity = 1 : bttBtn.style.opacity = 0;
}
window.onscroll = () => scroll();

document.addEventListener('DOMContentLoaded',
    () => {
        const overlay = document.getElementById('overlay');
        overlay.remove();
        const sidebarmenu = document.getElementById('sidebarmenu');
        sidebarmenu.remove();
        const root = document.getElementById('root');
        scroll();

        sidebarmenu.open = () => {
            document.body.append(overlay, sidebarmenu);
            overlay.setAttribute('data-state', 'open');
            overlay.classList.remove('hidden');
            sidebarmenu.setAttribute('data-state', 'open');
            sidebarmenu.classList.remove('hidden');
            document.body.setAttribute('style', "pointer-events: none;");
            document.body.setAttribute('data-scroll-locked', 1);
            root.setAttribute('data-aria-inert', true);
            root.setAttribute('aria-inert', true);
        }

        sidebarmenu.close = () => {
            document.body.removeAttribute('style');
            document.body.removeAttribute('data-scroll-locked');
            overlay.setAttribute('data-state', 'closed');
            overlay.addEventListener("animationend", (e) => {
                e.currentTarget.remove();
            }, {once: true});
            sidebarmenu.setAttribute('data-state', 'closed');
            sidebarmenu.addEventListener("animationend", (e) => {
                e.currentTarget.remove();
            }, {once: true});
            root.removeAttribute('data-aria-inert');
            root.removeAttribute('aria-inert');
        }
        menu.querySelector('button').addEventListener('click', e => sidebarmenu.open());
        sidebarmenu.querySelectorAll('button, a').forEach(element => element.addEventListener('click', e => sidebarmenu.close()));
        overlay.addEventListener('click', e => sidebarmenu.close());

    }, {once: true}
)


// btnMenuOpen.addEventListener('click', e => open());
// btnMenuClose.addEventListener('click', e => close());
